module.exports = __webpack_public_path__ + "static/font-071071c5de6572f64d4018a149569417.woff";